/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class CreateScanningApp200Response {
  /**
  * The Application ID of the created multi-tenant app
  */
  'appId'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "appId",
      "baseName": "appId",
      "type": "string",
      "format": "uuid"
    }  ];

  static getAttributeTypeMap() {
    return CreateScanningApp200Response.attributeTypeMap;
  }

  public constructor() {
  }
}

